import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'

import { Box, Hidden, Typography } from '@material-ui/core'

import useMobileBreakpoint from 'artkive/hooks/useMobileBreakpoint'

import lines from 'images/ecom/get-started/lines_3.svg'

import {
  Card,
  Content,
  ContentBox,
  ImageContainer,
  ImageWrapper,
  LinesImage,
  StyledTrackButton,
} from './YouWillAlsoLoveCarousel.style'

const ProductSlide = forwardRef(
  (
    { badge, image, bgColor, title, description, price, href, trackerEvent, trackerOptions, buttonLabel, classes = {} },
    ref,
  ) => {
    const isMobile = useMobileBreakpoint()

    return (
      <Card ref={ref}>
        <ContentBox>
          <ImageContainer bgColor={bgColor}>
            <ImageWrapper>
              {badge}
              {image}
            </ImageWrapper>
          </ImageContainer>
          <Content className={classes.content}>
            <Box mb={2}>
              <Typography variant='h3'>{title}</Typography>
            </Box>
            <Box mb={2}>
              <Typography>{description}</Typography>
            </Box>
            <Box
              display='flex'
              mb={3}
              alignItems='baseline'
              justifyContent={isMobile ? 'center' : 'flex-start'}
              className={classes.price}
            >
              <Typography variant='body1' align='inherit'>
                {price}
              </Typography>
            </Box>
            <StyledTrackButton
              className={classes.button}
              color='primary'
              size='large'
              href={href}
              variant='contained'
              trackerEvent={trackerEvent}
              trackerOptions={trackerOptions}
            >
              {buttonLabel}
            </StyledTrackButton>
            <Hidden smDown>
              <LinesImage src={lines} className={classes.lines} />
            </Hidden>
          </Content>
        </ContentBox>
      </Card>
    )
  },
)

ProductSlide.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  buttonLabel: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  image: PropTypes.node.isRequired,
  bgColor: PropTypes.string.isRequired,
  trackerEvent: PropTypes.string,
  trackerOptions: PropTypes.object,
  badge: PropTypes.node,
  price: PropTypes.node,
  classes: PropTypes.shape({
    content: PropTypes.string,
    price: PropTypes.string,
    button: PropTypes.string,
    lines: PropTypes.string,
  }),
}
export default ProductSlide
